import React from "react"
import { ListItem } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/styles"
import NavLinkItem from "../NavLinkItem"

const useStyles = makeStyles((theme) => ({
  navLinkListItem: {
    padding: 0,
    "&:hover": {
      background: "#ecf4ff",
      borderRadius: "4px",
      textDecoration: "none",
    },
    "&:focus": {
      background: "#ecf4ff",
      borderRadius: "4px",
      textDecoration: "none",
    },
  },
  navLinkItem: {
    display: "flex",
    flexGrow: 1,
    fontSize: 16,
    fontWeight: 600,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  navLinkItemText: {
    color: ({ color }) => color || theme.palette.primary.main,
    borderLeft: ({ active, color }) => (active ? `solid 3px ${color || theme.palette.primary.main}` : null),
    paddingLeft: ({ active }) => (active ? theme.spacing(1.25) : 0),
    whiteSpace: "nowrap",
    maxWidth: 200,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}))

const SubNavigationListItem = ({
  active,
  color,
  badgeVariant = "badge",
  badgeCount,
  badgeShowZero = true,
  text: textInput,
  ...props
}) => {
  const classes = useStyles({ active, color })
  const theme = useTheme()

  const text =
    badgeVariant === "text" && (badgeCount || (badgeShowZero && typeof badgeCount !== "undefined"))
      ? `${textInput} (${badgeCount})`
      : textInput

  return (
    <ListItem classes={{ root: classes.navLinkListItem }} disableGutters>
      <NavLinkItem
        className={classes.navLinkItem}
        badgeStyleProps={{
          color: "white",
          backgroundColor: theme.palette.primary.main,
        }}
        text={<span className={classes.navLinkItemText}>{text}</span>}
        badgeCount={badgeVariant === "badge" ? badgeCount : null}
        badgeShowZero={badgeShowZero}
        {...props}
      />
    </ListItem>
  )
}

export { SubNavigationListItem, useStyles as useSubNavigationListItemStyles }
